import {Component, OnInit, ViewChild} from '@angular/core';
import {MatButton} from '@angular/material/button';
import {MatProgressBar} from '@angular/material/progress-bar';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {CustomValidators} from 'ngx-custom-validators';
import {UserService} from '../../../shared/services/user.service';
import {ActivatedRoute, Router} from '@angular/router';
import {UrlService} from '../../../shared/services/url.service';
import {TranslateService} from '@ngx-translate/core';
import {StorageService} from '../../../shared/services/storage.service';
import {Store} from '@ngxs/store';
import {Observable} from 'rxjs';
import {CurrentUser} from '../../../shared/models/current-user.model';
import {PopupWindowsService} from '../../../shared/services/popup-windows.service';

@Component({
    selector: 'app-signup',
    templateUrl: './signup.component.html',
    styleUrls: ['./signup.component.css'],
})
export class SignupComponent implements OnInit {
    @ViewChild(MatProgressBar) progressBar: MatProgressBar;
    @ViewChild(MatButton) submitButton: MatButton;

    password = new FormControl('', Validators.required);
    confirmPassword = new FormControl('', CustomValidators.equalTo(this.password));
    signupForm: FormGroup = this.fb.group({
        email: ['', [Validators.pattern(new RegExp('^[-\\w.]+@([A-z0-9][-A-z0-9]+\\.)+[A-z]{2,4}$')), Validators.required]],
        password: this.password,
        confirmPassword: this.confirmPassword,
        agreed: [false, Validators.requiredTrue],
        rememberMe: [false]
    });
    public emailErrMsg: string;
    public hasAdmin$ = this.urlService.domainHasAnAdmin.asObservable();
    currentUser$: Observable<CurrentUser>;

    constructor(
        public translate: TranslateService,
        private userService: UserService,
        private router: Router,
        private fb: FormBuilder,
        private urlService: UrlService,
        private storageService: StorageService,
        private route: ActivatedRoute,
        private store: Store,
        private popupWindowsService: PopupWindowsService
    ) {
        this.currentUser$ = this.store.select(state => state.currentUser.currentUser);
    }

    ngOnInit() {
    }

    signup() {
        const signupData = this.signupForm.value;
        const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const language = this.translate.currentLang;
        this.submitButton.disabled = true;
        this.progressBar.mode = 'indeterminate';
        this.userService.signup(signupData.email, signupData.password, signupData.rememberMe, timeZone, language)
            .subscribe(
                res => {
                    this.submitButton.disabled = false;
                    this.progressBar.mode = 'determinate';

                    this.router.navigateByUrl('/profile/settings');
                },
                err => {
                    this.submitButton.disabled = false;
                    this.progressBar.mode = 'determinate';
                        if (err.status === 409) {
                        this.emailErrMsg = err.error.detail;
                        this.signupForm.markAsPristine();
                    } else {
                      this.popupWindowsService.openErrorDialogWindow({message: err.error.detail});
                    }
                }
            );
    }
}
